"use client";

import { i18n } from "i18next";
import { createContext, useContext } from "react";

export const I18nContext = createContext<i18n | undefined>(undefined);
// This may look a redundant function definition but it is necessary for tests to mock it
export const useI18nextContext: () => i18n | undefined = () =>
  useContext(I18nContext);
